export class APIError {
  statusCode: number;

  constructor(statusCode: number) {
    this.statusCode = statusCode;
  }
}
